export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "HDFC Bank Personal Loan EMI Calculator: Plan Your Loan Repayments with Ease",
    subHeading:
      "Use the HDFC Bank Personal Loan EMI Calculator to quickly calculate your monthly repayment amount. Whether you're borrowing for personal needs, medical emergencies, or any other reason, knowing your EMI helps you manage your finances more effectively and avoid surprises. With the HDFC Bank EMI calculator, you can easily estimate your loan details and make informed decisions about your personal loan.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
